export default function EditPaymentMethodValidation(values: any) {
  let errors: any = {};

  if (values.cbu && !values.cbu) {
    errors.cbu = "El número de CBU es requerido";
  }

  if (values.cbu && values.cbu.length !== 22) {
    errors.cbu = "El número de CBU debe tener 22 digitos";
  }

  if (values.credit_card_number && values.credit_card_number.length > 16) {
    errors.credit_card_number = "El número de tarjeta es incorrecto";
  }

  if (values.credit_card_number && values.credit_card_number.length < 14) {
    errors.credit_card_number = "El número de tarjeta incorrecto";
  }

  if (values.credit_card_number && !values.credit_card_number) {
    errors.credit_card_number = "Campo requerido";
  }

 if (values.expiration_month < 1 || values.expiration_month > 12) {
  errors.expiration_month = "El mes de expiración debe ser un valor entre 1 y 12";
 }

 if (values.expiration_year < 1 || values.expiration_year > 12) {
  errors.expiration_year = "El año de expiración debe ser un valor entre 22 y 25"
 }

  return errors;
}
